import { useEffect, useState } from "react";
import { ArrowRight, Play } from "lucide-react";
import DemoCarousel from "@/components/landing/DemoCarousel";

export default function Hero() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  return (
    <section id="top" className="yg-grid-bg relative pt-[96px] sm:pt-[120px] pb-14 sm:pb-20 overflow-hidden" data-testid="hero-section">

      <div className="max-w-[1240px] mx-auto px-5 sm:px-8 grid lg:grid-cols-[minmax(0,0.95fr)_minmax(0,1.05fr)] gap-8 lg:gap-14 items-center">
        {/* Copy */}
        <div className={`min-w-0 ${mounted ? "yg-reveal" : "opacity-0"}`}>
          <span className="yg-pill" data-testid="hero-pill">
            <span className="yg-dot" /> AI · Web · Apps · Automation
          </span>

          <h1
            className="yg-display text-[clamp(46px,9vw,86px)] mt-5 text-white"
            data-testid="hero-headline"
          >
            An AI technology
            <br />
            company for <span className="text-[var(--yg-violet-light)]">growth.</span>
          </h1>

          <div className="mt-4 inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 border border-[var(--yg-violet)]/35 bg-[var(--yg-violet)]/[0.08]" data-testid="hero-tagline">
            <span className="w-1.5 h-1.5 rounded-full bg-[var(--yg-violet-light)]" />
            <span className="text-[12.5px] text-white/90 font-medium tracking-[-0.005em]">
              <span className="yg-display text-[15px] tracking-normal text-[var(--yg-violet-light)] mr-1">&lsquo;युग&rsquo;</span>
              of growth by AI &amp; automation
            </span>
          </div>

          <p className="mt-5 max-w-[460px] text-[15.5px] sm:text-[17px] leading-[1.5] text-[var(--yg-text-mute)]" data-testid="hero-sub">
            We design <span className="text-white font-semibold">websites</span>, ship <span className="text-white font-semibold">mobile apps</span>, and deploy <span className="text-white font-semibold">AI agents &amp; automation</span> that run your business — 24/7.
          </p>

          <div className="mt-7 flex flex-wrap gap-3" data-testid="hero-ctas">
            <a href="#audit" className="yg-btn yg-btn-primary" data-testid="hero-cta-audit">
              Free AI Audit <ArrowRight className="w-4 h-4" />
            </a>
            <a href="#product" className="yg-btn yg-btn-ghost" data-testid="hero-cta-demo">
              <Play className="w-4 h-4" /> See demos
            </a>
          </div>

          <div className="mt-7 flex flex-wrap items-center gap-x-5 gap-y-2 text-[10.5px] font-medium tracking-[0.22em] uppercase text-[var(--yg-text-dim)] yg-mono">
            <span className="inline-flex items-center gap-2"><span className="yg-dot" /> Live 24/7</span>
            <span>21 services</span>
            <span>8 industries</span>
          </div>
        </div>

        {/* Demo panel */}
        <div className={`min-w-0 ${mounted ? "yg-reveal" : "opacity-0"}`} style={{ animationDelay: "120ms" }}>
          <DemoCarousel />
        </div>
      </div>
    </section>
  );
}
